module.exports = __webpack_public_path__ + "static/media/hand-point-up.507a0998.svg";